import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IReporte,
  ICreateReporte,
  IListado,
  IQueryParam,
  IUpdateReporte,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class ReportesService {
  constructor(private http: HttpService) {}

  public listar(queryParams?: IQueryParam): Observable<IListado<IReporte>> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/reportes`, { params });
  }

  public crear(dato: ICreateReporte): Observable<IReporte> {
    return this.http.post(`${api}/reportes`, dato);
  }

  public listarPorId(id: string): Observable<IReporte> {
    return this.http.get(`${api}/reportes/${id}`);
  }

  public editar(id: string, dato: IUpdateReporte): Observable<IReporte> {
    return this.http.put(`${api}/reportes/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/reportes/${id}`);
  }
}
